module.exports = __webpack_public_path__ + "img/Group3177.fd553bc6.png";